import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCompanyListModule } from "./helpAndAssistantApi";

export interface CompanyListState {
  companylist: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: CompanyListState = {
    companylist: [],
  status: "idle",
};

export const GetCompanyList = createAsyncThunk(
  "companyList/fetchCompany",
  async () => {
    const response = await fetchCompanyListModule();
    return response;
  }
);

export const companyListSlice = createSlice({
  name: "companyList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCompanyList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCompanyList.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCompanyList.fulfilled, (state, action) => {
        state.status = "idle";
        state.companylist = action.payload.company;
      });
  },
});

export const {} = companyListSlice.actions;

export const selectCompanyList = (state: RootState) => {
  return state.CompanyList.companylist;
};

export default companyListSlice.reducer;
